export default function CTASection() {
  return (
    <section className="w-full bg-background-50 px-6 md:px-10 py-16 md:py-20">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
          Access the Most Updated{" "}
          <span className="text-primary-500">Pandabuyspreadsheet</span>{" "}
          Collections Now
        </h2>
        <p className="mt-4 text-sm text-foreground-500 max-w-lg mx-auto leading-relaxed">
          One click away from thousands of curated products across 14 categories.
          Fast, organized, and always fresh.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-secondary-600 text-background-50 text-sm hover:bg-secondary-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Buy It Now
          <i className="ri-arrow-right-line text-base"></i>
        </a>
      </div>

      <div className="mt-14 overflow-hidden">
        <div className="flex items-end gap-0">
          <div className="flex-shrink-0 w-[160px] h-[200px] md:w-[200px] md:h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Trendy%20white%20sneaker%20isolated%20on%20warm%20peach%20gradient%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20ecommerce%20style%2C%20fresh%20contemporary%20aesthetic&width=400&height=560&seq=cta-strip-01-v4&orientation=portrait"
              alt="Pandabuyspreadsheet product 1"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-[160px] h-[200px] md:w-[200px] md:h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20forest%20green%20hoodie%20isolated%20on%20soft%20cream%20gradient%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20ecommerce%20style%2C%20natural%20earthy%20aesthetic&width=400&height=560&seq=cta-strip-02-v4&orientation=portrait"
              alt="Pandabuyspreadsheet product 2"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-[160px] h-[200px] md:w-[200px] md:h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20leather%20crossbody%20bag%20isolated%20on%20soft%20lavender%20gradient%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20ecommerce%20style%2C%20feminine%20contemporary%20aesthetic&width=400&height=560&seq=cta-strip-03-v4&orientation=portrait"
              alt="Pandabuyspreadsheet product 3"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-[160px] h-[200px] md:w-[200px] md:h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20aviator%20sunglasses%20isolated%20on%20warm%20sand%20gradient%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20ecommerce%20style%2C%20chic%20summer%20aesthetic&width=400&height=560&seq=cta-strip-04-v4&orientation=portrait"
              alt="Pandabuyspreadsheet product 4"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-[160px] h-[200px] md:w-[200px] md:h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Vintage%20wash%20denim%20jacket%20isolated%20on%20warm%20terracotta%20gradient%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20ecommerce%20style%2C%20retro%20contemporary%20aesthetic&width=400&height=560&seq=cta-strip-05-v4&orientation=portrait"
              alt="Pandabuyspreadsheet product 5"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-[160px] h-[200px] md:w-[200px] md:h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20gold%20watch%20isolated%20on%20soft%20mint%20gradient%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20ecommerce%20style%2C%20elegant%20luxury%20aesthetic&width=400&height=560&seq=cta-strip-06-v4&orientation=portrait"
              alt="Pandabuyspreadsheet product 6"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-[160px] h-[200px] md:w-[200px] md:h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Bold%20red%20graphic%20t-shirt%20isolated%20on%20soft%20sky%20blue%20gradient%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20ecommerce%20style%2C%20playful%20streetwear%20aesthetic&width=400&height=560&seq=cta-strip-07-v4&orientation=portrait"
              alt="Pandabuyspreadsheet product 7"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-[160px] h-[200px] md:w-[200px] md:h-[260px]">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20isolated%20on%20soft%20rose%20gradient%20background%2C%20clean%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20modern%20ecommerce%20style%2C%20luxurious%20feminine%20aesthetic&width=400&height=560&seq=cta-strip-08-v4&orientation=portrait"
              alt="Pandabuyspreadsheet product 8"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}